import {CustomersController} from './route/CustomersController';
import '../customer_profile/route/CustomerProfile.scss';
import {CustomersModuleConfiguration} from "./CustomersModuleConfiguration";
import {CustomersList} from "./component/customers-list/customers-list";
import {ProductCodeSelector} from "modules/customers/component/filters/product-code/productCodeSelector";

CustomersModuleConfiguration
    .createNewModule()
    .controller('customerController', CustomersController.instance)
    .component('productCodeSelector', ProductCodeSelector.instance)
    .component('customersList', CustomersList.instance);

